// API base URL — production'da aynı origin, development'ta aynı hostname:5000
// Bu sayede ağdaki diğer cihazlardan da (telefon vb.) erişilebilir
const API_URL = process.env.REACT_APP_API_URL
  || (process.env.NODE_ENV === 'production'
    ? ''
    : `http://${window.location.hostname}:5000`);

export default API_URL;
